import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { Switch, Tooltip } from 'antd'

class TableHeader extends Component {
    state = {
        tooltipVisible: true,
        hintActive: true,
    }

    componentDidMount() {
        this._hintTimeout = setTimeout(() => {
            this.setState({ tooltipVisible: false, hintActive: false })
        }, 8000)
    }

    componentWillUnmount() {
        clearTimeout(this._hintTimeout)
    }

    _handleTooltipVisibleChange = (visible) => {
        if (this.state.hintActive) return

        this.setState({ tooltipVisible: visible })
    }

    render() {
        const { noteTagFilter = 'exclude', onChangeNoteTagFilter, loading } = this.props
        const { tooltipVisible } = this.state
        const isExcluding = noteTagFilter === 'exclude'

        return (
            <thead className='TableHeader'>
            <tr className='text-center CustomHeadTable'>
                <th className="colType borderRight font-weight-bold"/>
                <th colSpan={5} className='borderRight font-weight-bold backgroundBorder3'>Ngày sản xuất còn lại</th>
                <th colSpan={7} className='borderRight font-weight-bold backgroundBorder6'>
                    <div className="d-flex align-items-center justify-content-center">
                        <span className="mr-2">Quá hạn sản xuất (do note)</span>
                        <Tooltip
                            title={isExcluding ? 'Ngoại trừ: Hold ship, Request design' : 'Hiển thị tất cả (gồm cả Hold ship, Request design)'}
                            visible={tooltipVisible}
                            onVisibleChange={this._handleTooltipVisibleChange}
                        >
                            <Switch
                                size="small"
                                checked={isExcluding}
                                disabled={loading}
                                onChange={checked => onChangeNoteTagFilter(checked ? 'exclude' : 'all')}
                                style={isExcluding ? { backgroundColor: '#0f9d58' } : undefined}
                            />
                        </Tooltip>
                    </div>
                </th>
                <th colSpan={9} className='font-weight-bold backgroundBorder8'>Quá hạn sản xuất</th>
            </tr>
            <tr className='text-right'>
                <th className="colType borderRight font-weight-bold"/>
                {/* <th className='border1'>6 ngày</th> */}
                {/* <th className='border1'>5 ngày</th> */}
                <th className='border1'>4 ngày</th>
                <th className='border2'>3 ngày</th>
                <th className='border3'>2 ngày</th>
                <th className='border4'>1 ngày</th>
                <th className="colTotal borderRight border5">Tổng</th>
                <th className='border11'>1 ngày</th>
                <th className='border12'>2 ngày</th>
                <th className='border13'>3 ngày</th>
                <th className='border14'>4 ngày</th>
                <th className='border15'>5 ngày</th>
                <th className='border15'>6 ngày</th>
                <th className="colTotal borderRight border15">Tổng</th>
                <th className='border6'>1 ngày</th>
                <th className='border6'>1.5 ngày</th>
                <th className='border7'>2 ngày</th>
                <th className='border7'>2.5 ngày</th>
                <th className='border8'>3 ngày</th>
                <th className='border9'>4 ngày</th>
                <th className='border9'>5 ngày</th>
                <th className='border9'>6 ngày</th>
                <th className="colTotal border10">Tổng</th>
            </tr>
            </thead>
        )
    }
}

TableHeader.propTypes = {
    noteTagFilter: PropTypes.string,
    onChangeNoteTagFilter: PropTypes.func,
    loading: PropTypes.bool,
}

export default TableHeader
